import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import styles from "./styles/style.module.scss";
import { FormattedMessage } from "react-intl";
import { handleImage } from "../../handlers";
import { htmlToExcerpt } from "../../helpers/functions";
import Image from "next/image";

const Blogs = ({ blogs }) => {
  const { locale } = useRouter();

  const formatDate = (dateString, locale) => {
    return new Intl.DateTimeFormat(
      locale === "ar" ? "ar-EG-u-nu-latn" : "en-GB-u-nu-latn",
      {
        day: "numeric",
        month: "long",
        year: "numeric",
      }
    ).format(new Date(dateString));
  };

  const sortedBlogs = blogs?.sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );

  return (
    <div className={styles["blogs-page"]}>
      <div className="wrapper">
        <Row className="cards-container gy-4">
          {sortedBlogs?.map((blog, index) => {
            return (
              <Col
                xxl={3}
                xl={4}
                lg={6}
                md={6}
                sm={12}
                xs={12}
                key={index}
                className="d-flex justify-content-center"
              >
                <Card className="card-item h-100">
                  <Link href={`/blogs/${blog?.id}`} legacyBehavior>
                    <a aria-label="card-link">
                      <Image
                        variant="top"
                        src={handleImage(blog?.image)}
                        className="card-image"
                        width={300}
                        height={200}
                        alt={blog?.title?.[locale]}
                      />
                    </a>
                  </Link>
                  <Card.Body className="card-body pb-0">
                    <Link href={`/blogs/${blog?.id}`} legacyBehavior>
                      <a aria-label="card-link">
                        <Card.Title className="title">
                          {blog?.title?.[locale]}
                        </Card.Title>
                      </a>
                    </Link>
                    <Card.Text as="div" className="description">
                      <div>{htmlToExcerpt(blog?.description?.[locale])}</div>
                    </Card.Text>
                    {blog?.category && (
                      <div className="d-flex category">
                        <b>
                          <FormattedMessage id="category" />:{" "}
                        </b>
                        <span>{blog?.category?.title?.[locale]}</span>
                      </div>
                    )}
                    {blog?.createdAt && (
                      <div className="d-flex date">
                        <b>
                          <FormattedMessage id="PublishDate" />:{" "}
                        </b>
                        <span locale={locale}>
                          {formatDate(blog?.createdAt, locale)}
                        </span>
                      </div>
                    )}
                    <Link href={`/blogs/${blog?.id}`} legacyBehavior>
                      <a aria-label="card-link">
                        <Button className="card-btn" variant="transparent">
                          <FormattedMessage id="read-more" />
                        </Button>
                      </a>
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default Blogs;
